document.addEventListener('DOMContentLoaded', function () {
  const addonBox = document.querySelector('[data-tomte-family-addons]');
  if (!addonBox) return;

  const infoContainer = addonBox.closest('.product__info-container');
  if (!infoContainer) return;

  const productFormElement = infoContainer.querySelector('product-form');
  if (!productFormElement) return;

  const form = productFormElement.querySelector('form');
  if (!form) return;

  form.addEventListener(
    'submit',
    async function (event) {
      const panInput = addonBox.querySelector('[data-addon-type="pan"]');
      const gnomeInput = addonBox.querySelector('[data-addon-type="gnome"]');

      const panQty = parseInt(panInput?.value || '0', 10);
      const gnomeQty = parseInt(gnomeInput?.value || '0', 10);

      // No add-ons selected. Keep normal theme behavior.
      if (panQty === 0 && gnomeQty === 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const mainVariantInput = form.querySelector('[name="id"]');

      const mainQuantityInput =
        infoContainer.querySelector('input[name="quantity"]') ||
        form.querySelector('[name="quantity"]');

      if (!mainVariantInput || !mainVariantInput.value) {
        alert('Unable to identify the Tomte Cake Set.');
        return;
      }

      const items = [
        {
          id: parseInt(mainVariantInput.value, 10),
          quantity: parseInt(mainQuantityInput?.value || '1', 10)
        }
      ];

      if (panQty > 0) {
        items.push({
          id: parseInt(panInput.dataset.variantId, 10),
          quantity: panQty
        });
      }

      if (gnomeQty > 0) {
        items.push({
          id: parseInt(gnomeInput.dataset.variantId, 10),
          quantity: gnomeQty
        });
      }

      const submitButton = form.querySelector('[type="submit"]');

      try {
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
        }

        const root =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';

        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items
          })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Unable to add the selected items to cart.'
          );
        }

        window.location.href = root + 'cart';
      } catch (error) {
        console.error('Tomte Family Add-ons:', error);

        if (submitButton) {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
        }

        alert(
          error.message ||
          'Unable to add the selected items to cart.'
        );
      }
    },
    true
  );
});